__webpack_require__.p = "/tokens-chart-primary-fix/account-setup/";